// API Configuration
export const PECLET_API_KEY = process.env.REACT_APP_PECLET_API_KEY;
export const HUNTER_API_KEY = process.env.REACT_APP_HUNTER_API_KEY;
export const MAP_KEY = process.env.REACT_APP_MAP_KEY;

// Map Configuration
export const DEFAULT_CENTER = [-32.23139, 146.20605];
export const DEFAULT_ZOOM = 5;
export const BOTTOM_SHEET_SNAP_HEIGHT = 350;

// Map Tile Configuration
export const TILE_URL = "https://{s}.tile.jawg.io/jawg-streets/{z}/{x}/{y}{r}.png?access-token=4cKtE4Rze1HrvxWa9a7mdolSk10lVThTFC8zadQYMIMxTjkpTeIDJAAmhReDGnCH";
export const TILE_ATTRIBUTION = '© <a href="http://jawg.io" title="Tiles by Jawg Maps" target="_blank">Jawg Maps</a> © <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

// Import icons
import coffee from '../assets/icons/coffee.svg';
import toilet from '../assets/icons/toilet.svg';
import bench from '../assets/icons/bench.svg';
import smile from '../assets/icons/smile.svg';
import shopping from '../assets/icons/shopping.svg';
import info from '../assets/icons/info-centre.svg';
import events from '../assets/icons/events.svg';
import smileMarker from '../assets/icons/smile-map-icon.svg';
import coffeeMarker from '../assets/icons/coffee-map-icon.svg';
import toiletMarker from '../assets/icons/toilet-map-icon.svg';
import shoppingMarker from '../assets/icons/shopping-map-icon.svg';
import infoMarker from '../assets/icons/info-centre-map-icon.svg';
import parkMarker from '../assets/icons/parks-map-icon.svg';
import eventsMarker from '../assets/icons/events-map-icon.svg';

// POI Filters Configuration
export const poiFilters = [
  { 
    name: 'Activities', 
    buttonIcon: smile, 
    mapIcon: smileMarker, 
    categoryValue: 'Activities' 
  },
  { 
    name: 'Food & Drinks', 
    buttonIcon: coffee, 
    mapIcon: coffeeMarker, 
    categoryValue: 'Food & Drinks' 
  },
  { 
    name: 'Restrooms', 
    buttonIcon: toilet, 
    mapIcon: toiletMarker, 
    categoryValue: 'Restrooms'
  },
  { 
    name: 'Visitor Centres', 
    buttonIcon: info,
    mapIcon: infoMarker, 
    categoryValue: 'Visitor Centres' 
  },
  { 
    name: 'Parks', 
    buttonIcon: bench, 
    mapIcon: parkMarker, 
    categoryValue: 'Parks' 
  },
  { 
    name: 'Shopping', 
    buttonIcon: shopping,
    mapIcon: shoppingMarker, 
    categoryValue: 'Shopping' 
  },
  { 
    name: 'Events', 
    buttonIcon: events,
    mapIcon: eventsMarker, 
    categoryValue: 'Events' 
  },

];

// Duration Options
export const DURATION_OPTIONS = [5, 10, 15, 20];

// Geolocation Configuration
export const GEOLOCATION_OPTIONS = {
  enableHighAccuracy: true,
  timeout: 15000,
  maximumAge: 300000
};

// Error Messages
export const ERROR_MESSAGES = {
  PERMISSION_DENIED: "Location access is required to find nearby EV chargers. Please allow location access in your browser settings and try again.",
  POSITION_UNAVAILABLE: "Unable to determine your location. Please check your device's GPS settings and try again.",
  TIMEOUT: "Location request took too long. Please check your internet connection and try again.",
  DEFAULT: "Unable to get your location. Please check your browser settings and try again.",
  GEOLOCATION_NOT_SUPPORTED: "Geolocation is not supported by your browser. Please use a modern browser."
}; 